export const getInstallationType = (installation) => {
    return installation ? "installationIndoor" : "installationOutdoor";
}

export const getFineFilterType = (unitType) => {
    const fineFilterType = unitType === "Compact:Prime" ? "Rigid bag filter" : "Soft bag filter";
    return fineFilterType;

}

export const getUnitTypeLabel = (unitType, isClivet) => {
    switch (unitType) {
        case "Compact:Prime":
            return isClivet ? "SETBRIEF" : "Compact:Prime";
        case "Energy:Prime Standard":
            return isClivet ? "SETBIS" : "Energy:Prime Standard";
        case "Energy:Prime Genius":
            return isClivet ? "SETBIS" : "Energy:Prime Genius";
        case "Modular:Prime":
            return isClivet ? "SETWIDE" : "Modular:Prime";
        case "Line:Prime":
            return isClivet ? "SETWIDE" : "Modular:Prime";
        default:
            return unitType;
    }
}
